'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobUserTemplate } from '../../Entities/Glob/GlobUserTemplate';
import { GlobUserTemplateCollection } from '../../Collections/Glob/GlobUserTemplateCollection';

export class GlobUserTemplateRepository extends CoreRepository {
  public getGlobUserTemplates() {
    return this.webAPI.getGlobUserTemplates().then((response) => {
      const collection = new GlobUserTemplateCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobUserTemplate();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
